<div class="card mb-3" *ngIf="ranking">
    <div class="card-body">
        <a [routerLink]="[linkRoute, ranking.id_ranking]" class="d-flex justify-content-between align-items-center">
            <div class="ranking-content">
                <h2 class="card-title">{{ ranking.nome_ranking }}</h2>
                <span class="label mt-auto">{{ "GENERAL.PERIOD" | translate }}</span>
                <p class="small color-white">
                    {{ ranking.dt_inicio }} {{ "GENERAL.UNTIL" | translate }} {{ ranking.dt_final }}
                </p>
            </div>
            <div>
                <img [src]="ranking.url_avatar" [alt]="ranking.nome_ranking" width="64px" height="64px" />
            </div>
        </a>
    </div>
</div>
